import { createContext } from 'react'

import { TransferListContextProps } from './types'

export const TransferListContext = createContext<TransferListContextProps>(
  {} as TransferListContextProps,
)
